import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="precio" className="bg-crema py-24 px-6 text-center" data-id="element-121">
      <div className="max-w-2xl mx-auto" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="flex justify-center mb-8" data-id="element-124">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-125">
              <circle cx="12" cy="12" r="10" data-id="element-126" />
              <path d="M8 14s1.5 2 4 2 4-2 4-2" data-id="element-127" />
              <line x1="9" y1="9" x2="9.01" y2="9" data-id="element-128" />
              <line x1="15" y1="9" x2="15.01" y2="9" data-id="element-129" />
            </svg>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-6 font-serif" data-id="element-131">
            Tu bebé está listo para aprender. La pregunta es cuándo empiezas tú.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-132">
          <p className="text-lg text-texto mb-10" data-id="element-133">
            Los bebés no esperan a que tengamos energía para enseñarles.
            <br data-id="element-134" />
            <br data-id="element-135" />
            Pero tú tienes algo que no tenías antes de leer esta página: sabes
            que el problema tiene nombre, tiene causa y tiene solución.
            <br data-id="element-136" />
            <br data-id="element-137" />
            <span className="font-bold text-azul-noche" data-id="element-138">
              Lo único que falta es el primer paso.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-139">
          <div className="mb-8" data-id="element-140">
            <p className="text-sm text-texto/60 mb-2 line-through" data-id="element-141">
              $19.99 USD
            </p>
            <p className="text-5xl md:text-6xl font-bold text-azul-noche mb-2" data-id="element-142">
              $6.39 <span className="text-xl font-medium" data-id="element-143">USD</span>
            </p>
            <p className="text-lila-suave font-bold text-lg" data-id="element-144">
              🔥 Oferta por tiempo limitado — 68% de descuento
            </p>
          </div>
          <motion.a href="https://www.vidaenvirtud.com/checkouts/cn/hWNBah5Al9xhe7zbtC40Hyq1/en-us?_r=AQABjKkAq2TMQxuaivOqfnEInWY7NIa0FiTatqiEocuXQgc" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-azul-noche text-white font-bold text-xl px-12 py-5 rounded-full shadow-lg hover:shadow-xl transition-shadow w-full sm:w-auto mb-6 no-underline" data-id="element-145">
            Empezar Esta Noche por Solo $6.39 →
          </motion.a>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-146">
          <p className="text-sm text-texto/70 font-medium" data-id="element-147">
            Sin riesgo · Garantía de 30 días · Acceso inmediato
          </p>
        </FadeIn>
      </div>
    </section>;
}